// Central place for the auth-related sessionStorage/localStorage keys, so
// call sites can't typo a key name or forget to clear one on logout.

export const getAccessToken = () =>
  sessionStorage.getItem("token") || sessionStorage.getItem("accessToken");

export const getRefreshToken = () => sessionStorage.getItem("refreshToken");

export const getLoginType = () => localStorage.getItem("loginType");

export const getLoginPath = () => (getLoginType() === "1" ? "/super-admin" : "/");

// Set between the login step and OTP verification: no session exists yet,
// just the id OtpVerification needs to submit the code against.
export const getPendingUserId = () => localStorage.getItem("userId");
export const setPendingUserId = (userId) =>
  localStorage.setItem("userId", userId);

// The only place a real, authenticated session should be established: after
// OTP verification succeeds.
export const setSession = ({ accessToken, refreshToken, userData, loginType }) => {
  if (accessToken) {
    sessionStorage.setItem("token", accessToken);
    sessionStorage.setItem("accessToken", accessToken);
  }
  if (refreshToken) {
    sessionStorage.setItem("refreshToken", refreshToken);
  }
  if (userData) {
    sessionStorage.setItem("userData", JSON.stringify(userData));
  }
  if (loginType) {
    localStorage.setItem("loginType", loginType);
  }
};

// Used by the token-refresh flow: rotate the tokens, keep the rest of the
// cached user data as-is (only expiresIn moves, falling back to the cached
// value if the refresh response didn't carry one).
export const updateStoredTokens = ({ accessToken, refreshToken, expiresIn }) => {
  if (!accessToken) return;

  sessionStorage.setItem("token", accessToken);
  sessionStorage.setItem("accessToken", accessToken);
  if (refreshToken) {
    sessionStorage.setItem("refreshToken", refreshToken);
  }

  const storedUserData = sessionStorage.getItem("userData");
  if (storedUserData) {
    try {
      const userData = JSON.parse(storedUserData);
      sessionStorage.setItem(
        "userData",
        JSON.stringify({
          ...userData,
          expiresIn: expiresIn ?? userData.expiresIn,
        }),
      );
    } catch {
      // Keep the refreshed tokens even if the cached user data is malformed.
    }
  }
};

export const clearSession = () => {
  sessionStorage.clear();
  localStorage.clear();
};
